module.exports = __webpack_public_path__ + "static/media/BL-PreLoader.0da7e500.gif";